import { useEffect } from 'react';
import { Trip } from '..';
import styles from './TripsList.module.scss';
import { useAppDispatch, useAppSelector } from '../../../app';
import {
  DAY_URL_NAME,
  TAG_URL_NAME,
  TOD_URL_NAME,
  setNothingFound,
} from '../../filter';
import { useSearchParams } from 'react-router-dom';
import { DateTime } from 'luxon';

export default function TripsList(): JSX.Element {
  const dispatch = useAppDispatch();
  const trips = useAppSelector(state => state.filter.trips);
  const isLoadingTrips = useAppSelector(state => state.filter.isLoadingTrips);

  const [searchParams] = useSearchParams();

  const selectedTimesOfDay = searchParams.get(TOD_URL_NAME)?.split(',') ?? [];
  const selectedTag = searchParams.get(TAG_URL_NAME);

  const selectedDateStr = searchParams.get(DAY_URL_NAME);
  const selectedLuxonDate = selectedDateStr
    ? DateTime.fromFormat(selectedDateStr, 'dd.MM.yyyy')
    : undefined;
  const selectedDateTimestamp = selectedLuxonDate?.toMillis();

  useEffect(() => {
    if (!trips || isLoadingTrips) {
      return;
    }

    dispatch(setNothingFound(false));

    if (trips.length === 0) {
      if (
        selectedTag !== null ||
        selectedTimesOfDay.length !== 0 ||
        selectedDateTimestamp
      ) {
        dispatch(setNothingFound(true));
      }
    }
  }, [trips, selectedTag, selectedTimesOfDay, selectedDateTimestamp]);

  return (
    <ul className={styles.container}>
      {trips?.map((trip: any) => (
        <Trip
          key={trip.id}
          trip={trip}
          isDateSelected={!!selectedDateTimestamp}
        />
      ))}
    </ul>
  );
}
